import notificationSettingsTemplate from './views/notifications-settings.html';
import blackListSettingsTemplate from './views/black-lists-settings.html';
import profileDetailsTemplate from './views/profile-details.tpl.html';
import profileEditorTemplate from './views/profile-editor.tpl.html';

import indexTemplateUrl from './views/index.tpl.html';
import SettingsIndexPageController from './controllers/index-controller';

import customFieldsTemplate from './views/custom-fields.tpl.html';
import ContactCustomFieldsSettingsPageController from './controllers/custom-fields/contact-custom-fields';
import GuestlistCustomFieldsSettingsPageController from './controllers/custom-fields/guestlist-custom-fields';

angular
    .module('festzelt-os.settings')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.settings', {
            abstract: true,
            url: '/settings',
            template: '<ui-view />',
            params: {
                company: {
                    type: 'any',
                    inherit: true,
                    value: null
                },
                user: {
                    type: 'any',
                    inherit: true,
                    value: null
                }
            }
        })
        .state('app.settings.index', {
            url: '',
            data: {
                view: 'custom'
            },
            templateUrl: indexTemplateUrl,
            controller: SettingsIndexPageController,
            controllerAs: 'vm'
        })
        .state('app.settings.custom-fields', {
            abstract: true,
            url: '/custom-fields',
            template: '<ui-view />'
        })
        .state('app.settings.custom-fields.contact', {
            url: '/contact',
            data: {
                rights: 'companies::edit'
            },
            templateUrl: customFieldsTemplate,
            controller: ContactCustomFieldsSettingsPageController,
            controllerAs: 'vm'
        })
        .state('app.settings.custom-fields.guestlist', {
            url: '/guestlist',
            data: {
                rights: 'companies::edit'
            },
            templateUrl: customFieldsTemplate,
            controller: GuestlistCustomFieldsSettingsPageController,
            controllerAs: 'vm'
        })
        .state('app.settings.notifications', {
            url: '/notifications',
            sticky: true,
            data: {
                rights: 'companies::edit'
            },
            templateUrl: notificationSettingsTemplate,
            controller: 'NotificationsCtrl',
            controllerAs: 'vm'
        })
        .state('app.settings.blacklists', {
            url: '/blacklists',
            sticky: true,
            data: {
                rights: 'companies::edit'
            },
            templateUrl: blackListSettingsTemplate,
            controller: 'BlacklistsCtrl',
            controllerAs: 'vm'
        })
        .state('app.settings.profile-details', {
            url: '/profile',
            controller: 'ProfileDetailsCtrl',
            controllerAs: 'vm',
            templateUrl: profileDetailsTemplate
        })
        .state('app.settings.profile-edit', {
            url: '/profile/edit',
            controller: 'ProfileEditCtrl',
            controllerAs: 'vm',
            templateUrl: profileEditorTemplate
        });
}



// WEBPACK FOOTER //
// ./src/app/pages/settings/settings-routes.js